import { useState, useEffect } from 'react'
import { useFetching } from 'components/hooks/useFetching'
import { useDispatch } from 'react-redux'
import { setSidebarItem } from 'redux/slice/sidebarItemSlice'
import CommandService from 'services/CommandService'
import Loader from 'components/UI/loader/Loader'
import TitleMain from 'components/UI/titleMain/TitleMain'
import { NotificationManager } from 'react-notifications'
import Strings from 'values/Strings'
import CommandSelector from './CommandSelector'
import ImageUploader from './ImageUploader'
import CommandInfo from './CommandInfo'
import classes from './TeamManagementPage.module.css'

function TeamManagementPage() {
    const dispatch = useDispatch()
    const [commands, setCommands] = useState([])
    const [commandList, setCommandList] = useState([])
    const [selectedCommand, setSelectedCommand] = useState({})
    const [commandValue, setCommandValue] = useState('')

    useEffect(() => {
        // Устанавливаем активный элемент сайдбара при загрузке страницы
        dispatch(setSidebarItem(Strings.sidebarTeamManagement))
    }, [dispatch])

    const notificationError = (error) => {
        if (error?.response?.data?.message) {
            NotificationManager.error(error.response.data.message, Strings.notificationsErrorTitle, 5000)
        } else if (error?.message) {
            NotificationManager.error(error.message, Strings.notificationsErrorTitle, 5000)
        } else {
            NotificationManager.error('Произошла ошибка', Strings.notificationsErrorTitle, 5000)
        }
    }

    const [fetchingCommands, loadingCommands] = useFetching(async () => {
        try {
            const res = await CommandService.getAllCommandsForAdmin()
            
            if (res && Array.isArray(res) && res.length > 0) {
                setCommands(res)
                const list = res.map(item => `${item.name} – стол №${item.table_number || 0} (${item.occasion_name})`)
                setCommandList(list)
            } else {
                setCommands([])
                setCommandList([])
            }
        } catch (error) {
            console.error('❌ [TeamManagementPage] Ошибка получения команд:', error)
            notificationError(error)
        }
    }, false)

    const [uploadingImage, loadingUpload] = useFetching(async (commandId, imageFile) => {
        try {
            const res = await CommandService.uploadCommandImage(commandId, imageFile)
            NotificationManager.success(res.message || 'Фотография успешно загружена', Strings.notificationsSuccessTitle, 3000)
            
            // Обновляем список команд с новым URL изображения
            const updatedCommands = commands.map(cmd => 
                cmd.id === commandId 
                    ? { ...cmd, image_url: res.image_url, image_command: res.command.image_command }
                    : cmd
            )
            setCommands(updatedCommands)
            
            // Обновляем выбранную команду
            if (selectedCommand.id === commandId) {
                const updatedCommand = {
                    ...selectedCommand,
                    image_url: res.image_url,
                    image_command: res.command.image_command
                }
                setSelectedCommand(updatedCommand)
            }
        } catch (error) {
            console.error('❌ [TeamManagementPage] Ошибка загрузки изображения:', error)
            notificationError(error)
        }
    }, false)

    const [removeCommandImage, loadingRemoveImage] = useFetching(async (commandId) => {
        try {
            const res = await CommandService.deleteCommandImage(commandId)
            NotificationManager.success(res.message || 'Фотография удалена', Strings.notificationsSuccessTitle, 3000)

            const updatedCommands = commands.map(cmd =>
                cmd.id === commandId
                    ? { ...cmd, image_url: null, image_command: res.command.image_command }
                    : cmd
            )
            setCommands(updatedCommands)

            if (selectedCommand.id === commandId) {
                const updatedCommand = { ...selectedCommand, image_url: null, image_command: res.command.image_command }
                console.log('🗑️ [TeamManagementPage] Обновление выбранной команды после удаления изображения')
                setSelectedCommand(updatedCommand)
            }
        } catch (error) {
            console.error('❌ [TeamManagementPage] Ошибка удаления изображения:', error)
            notificationError(error)
        }
    }, false)

    useEffect(() => {
        fetchingCommands()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function handleCommandSelect(data, index = -1) {
        if (index !== -1 && commands[index]) {
            setSelectedCommand(commands[index])
            setCommandValue(commandList[index])
        } else {
            setCommandValue(data)
        }
    }

    return (
        <Loader>
            <div className={classes.events__create__style}>
                <TitleMain text="Управление командами" jsc="center" fns="1.5vw" elpSize="0.9vw" />
                <div className={classes.contentWrapper}>
                    {loadingCommands && commandList.length === 0 ? (
                        <div className={classes.dropdownSkeleton}></div>
                    ) : (
                        <div className={classes.selectorWrapper}>
                            <CommandSelector
                                commands={commands}
                                commandList={commandList}
                                commandValue={commandValue}
                                onSelect={handleCommandSelect}
                            />
                        </div>
                    )}

                    {selectedCommand?.id && (
                        <div className={classes.commandDetails}>
                            <div className={classes.shadow__box__style}>
                                <ImageUploader
                                    selectedCommand={selectedCommand}
                                    onUpload={(file) => uploadingImage(selectedCommand.id, file)}
                                    loading={loadingUpload}
                                    onRemove={() => removeCommandImage(selectedCommand.id)}
                                    removing={loadingRemoveImage}
                                />
                            </div>

                            <div className={classes.shadow__box__style}>
                                <CommandInfo command={selectedCommand} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Loader>
    )
}

export default TeamManagementPage

